import { Card } from '@mui/material';
import { useState } from 'react';
import BlueskyPreview from 'src/pages/scheduledPost/Preview/BlueskyPreview/bluesky-preview.component';

import FacebookPreview from 'src/pages/scheduledPost/Preview/FacebookPreview/facebook-preview.component';
import GoogleMyBusinessPreview from 'src/pages/scheduledPost/Preview/GoogleMyBusinessPreview/gbusiness-preview.component';
import InstagramPreview from 'src/pages/scheduledPost/Preview/InstagramPreview/instagram-preview.component';
import LinkedinPreview from 'src/pages/scheduledPost/Preview/LinkedinPreview/linkedin-preview.component';
import PinterestPreview from 'src/pages/scheduledPost/Preview/PinterestPreview/pinterest-preview.component';
import ThreadsPreview from 'src/pages/scheduledPost/Preview/ThreadsPreview/threads-preview.component';
import TikTokPreview from 'src/pages/scheduledPost/Preview/TiktokPreview/tiktok-perview-component';
import TwitterPreview from 'src/pages/scheduledPost/Preview/TwitterPreview/twitter-preview.component';
import YoutubePreview from 'src/pages/scheduledPost/Preview/YoutubePreview/youtube-preview.component';
import SnapchatPreview from 'src/pages/scheduledPost/Preview/SnapchatPreview/snapchat-perview-component';

// Function to add connected profile details to post data

const PreviewComponent = ({ newPostForm, isOrgEvent }) => {
  const [height, setHeight] = useState(window.innerHeight - 200);
  let facebookData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.facebook_requests_data));
  let instagramData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.instagram_requests_data));
  let twitterData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.twitter_requests_data));
  let threadsData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.threads_requests_data));
  let blueskyData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.bluesky_requests_data));
  let youtubeData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.youtube_requests_data));
  let linkedinData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.linkedin_requests_data));
  let gbusinessData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.gbusiness_requests_data));
  let pinterestData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.pinterest_requests_data));
  let tiktokData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.tiktok_requests_data));
  let snapchatData = JSON.parse(JSON.stringify(newPostForm.scheduled_event_requests_data.snapchat_requests_data));
  return (
    <Card style={{ boxShadow: 'none', borderRadius: 1 }}>
      <FacebookPreview postDetails={facebookData} isOrgEvent={isOrgEvent} />
      <InstagramPreview postDetails={instagramData} isOrgEvent={isOrgEvent} />
      <TwitterPreview postDetails={twitterData} isOrgEvent={isOrgEvent} />
      <ThreadsPreview postDetails={threadsData} isOrgEvent={isOrgEvent} />
      <BlueskyPreview postDetails={blueskyData} isOrgEvent={isOrgEvent} />
      <YoutubePreview postDetails={youtubeData} isOrgEvent={isOrgEvent} />
      <LinkedinPreview postDetails={linkedinData} isOrgEvent={isOrgEvent} />
      <GoogleMyBusinessPreview postDetails={gbusinessData} isOrgEvent={isOrgEvent} />
      <PinterestPreview postDetails={pinterestData} isOrgEvent={isOrgEvent} />
      <TikTokPreview postDetails={tiktokData} isOrgEvent={isOrgEvent} />
      <SnapchatPreview postDetails={snapchatData} isOrgEvent={isOrgEvent} />
      {/* Add TikTokPreview if it exists and is needed */}
      {/* <TikTokPreview postDetails={modifiedTiktokData} /> */}
    </Card>
  );
};

export default PreviewComponent;
